import { render, staticRenderFns } from "./LayoutTavoloMobile.vue?vue&type=template&id=5ea0667a&scoped=true&"
import script from "./LayoutTavoloMobile.vue?vue&type=script&lang=js&"
export * from "./LayoutTavoloMobile.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTavoloMobile.vue?vue&type=style&index=0&id=5ea0667a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea0667a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea0667a')) {
      api.createRecord('5ea0667a', component.options)
    } else {
      api.reload('5ea0667a', component.options)
    }
    module.hot.accept("./LayoutTavoloMobile.vue?vue&type=template&id=5ea0667a&scoped=true&", function () {
      api.rerender('5ea0667a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/LayoutTavoloMobile.vue"
export default component.exports